// extracted by mini-css-extract-plugin
module.exports = {"iframe":"AppEditorViewer_iframe__1CYxS"};